import { Building2Icon, ExternalLink, UserIcon } from 'lucide-react'

import { adminEmployers } from 'rails_routes'
import { Badge } from 'slab'
import { AdminComplianceCheckEntityType } from 'utils/web_api.schemas'

interface EmployerComplianceEntityBadgeProps {
  entityType: AdminComplianceCheckEntityType
  entityId: string
  entityName: string
}

const EmployerComplianceEntityBadge = ({ entityType, entityId, entityName }: EmployerComplianceEntityBadgeProps) => {
  const truncateName = (name: string) => {
    return name.length > 25 ? `${name.substring(0, 25)}...` : name
  }

  if (entityType === AdminComplianceCheckEntityType.Employer) {
    return (
      <Badge
        type='info'
        leftIcon={Building2Icon}
        actionIcon={ExternalLink}
        onActionClick={() => {
          window.open(adminEmployers.show({ id: entityId }), '_blank')
        }}
      >
        {truncateName(entityName)}
      </Badge>
    )
  }

  if (entityType === AdminComplianceCheckEntityType['Compliance::Owner']) {
    return (
      <Badge
        type='info'
        leftIcon={UserIcon}
        actionIcon={ExternalLink}
        onActionClick={() => {
          window.open(`/admin/compliance_owners/${entityId}`, '_blank')
        }}
      >
        {truncateName(entityName)}
      </Badge>
    )
  }

  // Fallback for unknown entity types
  return (
    <Badge type='neutral'>
      {truncateName(entityName)}
    </Badge>
  )
}

export default EmployerComplianceEntityBadge
